var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":function($event){return _vm.copyLink()}}},[_vm._v("\n  "+_vm._s(_vm.t("copy_link"))+"\n  "),_c('i',{staticClass:"material-icons vertical-middle"},[_vm._v("\n    link\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }